<template>
  <div class="complete-register">
    <div class="l-container mx-auto px-4 pb-8">
      <Step :currentStep="4" :steps="steps" />
    </div>

    <div class="l-container pt-4 sm:pt-8">
      <h1 class="text-bold text-left">お申込み完了</h1>
      <a-divider />
      <div class="card mb-8 pb-8">
        <section>
          <h1 class="py-20 sm:py-12">お申込みありがとうございました</h1>
        </section>

        <section>
          <div class="order-brief">
            <div>
              受付番号：
              <span
                class="order-brief-code"
                v-if="get(completeOrderPublicStay, 'acptNo')"
              >
                {{ get(completeOrderPublicStay, 'acptNo') }}
              </span>
            </div>
          </div>
        </section>

        <section>
          カスタマーセンターへの問い合わせの際は受付番号をお知らせください。
        </section>

        <a-divider />

        <section class="mb-4">
          <Item :data="dataItemOrder" />
        </section>

        <section>
          <SectionContentTitle
            :lineType="lineType.vertical"
            :titleContent="titleContent[0]"
          />
          <div class="px-4 sm:px-0">
            <div class="flex flex-wrap items-center">
              <div class="w-full float-left">
                <div class="title-box-row">
                  <div class="w-1/4 sm:w-full">宿泊期間</div>
                  <div class="w-3/4 sm:w-full">
                    <span class="mr-2">
                      {{ get(stayDateRoom, 'date', '') }}
                    </span>
                    <span class="mr-2">
                      {{ get(stayDateRoom, 'stayNight', '') }} 泊
                    </span>
                    <span class="mr-2">
                      {{ get(stayDateRoom, 'stayRoom', '') }} 部屋
                    </span>
                    （大人{{ get(completeOrderPublicStay, 'totalAdult') }}名/子ども{{
                      get(completeOrderPublicStay, 'totalChild')
                    }}名）
                  </div>
                </div>
                <!--                <div class="title-box-row">-->
                <!--                  <div class="w-1/4 sm:w-full">チェックイン</div>-->
                <!--                  <div class="w-3/4 sm:w-full">{{ value_time_picker }}:00</div>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </section>
        <a-divider />
        <!-- <section class="my-8">
          <div class="share-options">
            <Share label="シェアする" :url="shareUrl" />

            <div class="flex items-center sm:mt-4" @click="handleMove">
              <a class="text-black"> お申し込みの詳細を見る </a>
              <span class="icon icon-bor-arrow-right sm color-primary"></span>
            </div>
          </div>
        </section> -->

        <section
          class="my-8 flex print-web-wrap"
          style="justify-content: space-between"
          v-if="+selectedRadio === 1"
        >
          <div class="print-web flex flex-col sm:pb-3">
            <span class="pb-3">
              「ご利用案内書」はこちらより印刷できます。プリントアウトして当日必ず現地へご提示ください。<br />
              ※マイページのご予約状況確認からも印刷可能です。
            </span>
            <a-button
              size="large"
              @click="downloadPublicStayGuide"
              style="border: 1px solid #0000009c"
              class="text-bold w-40 h-8 button-web"
              :disabled="!this.pdfFilePath"
              ><span class="block text-xs">ご利用案内書を印刷</span></a-button
            >
          </div>
          <a :href="pdfFilePath" ref="downloadUrl" download="New PDF Name.pdf"></a>
          <div class="share-options">
            <!-- CRM汎用独自対応 ↓↓↓↓↓ -->
            <!-- <Share label="シェアする" :url="shareUrl" /> -->
            <!-- CRM汎用独自対応 ↑↑↑↑↑ -->
            <div class="flex sm:mt-4" @click="handleMove(true)">
              <a class="text-black"> お申し込みの詳細を見る </a>
              <span class="icon icon-bor-arrow-right sm color-primary pt-2"></span>
            </div>
          </div>
        </section>

        <section class="my-8 flex" v-else style="justify-content: end">
          <div class="share-options">
            <!-- CRM汎用独自対応 ↓↓↓↓↓ -->
            <!-- <Share label="シェアする" :url="shareUrl" /> -->
            <!-- CRM汎用独自対応 ↑↑↑↑↑ -->
            <div class="flex sm:mt-4" @click="handleMove(true)">
              <a class="text-black"> お申し込みの詳細を見る </a>
              <span class="icon icon-bor-arrow-right sm color-primary pt-2"></span>
            </div>
          </div>
        </section>

        <!-- TODO:次回フェーズで使用する可能性があるためコメントアウト -->
        <!-- <a-divider />
        <section>
          <SectionContentTitle
            class="my-4"
            :lineType="lineType.vertical"
            :titleContent="titleContent[2]"
          />
          <div class="mb-4">
            <span>チェックを入れた内容の新着メニュー・プラン情報をお届けします。 </span>
          </div>
          <div class="flex gap-x-8 mb-4 sm:flex-col sm:gap-y-4">
            <a-checkbox v-model="checkboxValue" class="m-0">
              デイリーマガジン
            </a-checkbox>
            <a-checkbox v-model="checkboxValue1" class="m-0"> 週刊マガジン </a-checkbox>
            <a-checkbox v-model="checkboxValue2" class="m-0"> 月間マガジン </a-checkbox>
          </div>
          <div class="flex flex-col mb-4">
            <span>
              ※配信頻度は「あなたへのオススメ」の設定内容に準じたものとなります。
            </span>
            <span>
              ※配信停止は、マイページ「会員プロフィール設定」からお願いします。
            </span>
          </div>
          <div>
            <a-button size="large" @click="gotoPath" class="text-bold">設定する</a-button>
          </div>
        </section> -->
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import Share from './components/Share'
import { Item, Step, SectionContentTitle } from '@/components/compound'
import moment from 'moment'
import downLoadMixin from '@/mixins/download.js'
export default {
  components: {
    Item,
    Step,
    SectionContentTitle,
    Share
  },
  data() {
    return {
      recommendedItems: [],
      orderInfo: null,
      orderPublicStay: {},
      completeOrderPublicStay: {},
      finalOrderAmount: 0,
      ckinSchDatetime: '',
      value_time_picker: '',
      showPopUp: false,
      totalAdult: '',
      totalChild: '',
      dataItemOrder: {
        type: 'type-small',
        label: '',
        menu_id: '',
        menu_content: '',
        title1: '',
        title2: ''
      },
      info_lives: '',
      titleContent: [
        'お申し込み内容',
        '確認事項',
        '新着情報受信設定',
        '周辺のおすすめサービス',
        '確認事項'
      ],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      checkboxValue: false,
      checkboxValue1: false,
      checkboxValue2: false,
      pdfFilePath: null,
      selectedRadio: null,
      steps: [
        {
          id: 1,
          label: '申請内容を入力'
        },
        {
          id: 2,
          label: '申請者情報を入力'
        },
        {
          id: 3,
          label: '補助金利用申請'
        },
        {
          id: 4,
          label: '申込内容確認'
        },
        {
          id: 5,
          label: '申込完了'
        }
      ]
    }
  },

  mounted() {
    let orderData = _.get(this.$store.state, 'order.menuBasicInfo.menuNo', null)
    if (orderData === null) {
      this.$router.push("/interrupt")
      return
    }

    this.selectedRadio = _.get(this.$store.getters, 'bs_app.selected_web_radio', null)
    this.orderPublicStay = cloneDeep(this.$store.state.order.orderPublicStay)
    this.completeOrderPublicStay = cloneDeep(this.$store.state.order.completeOrderPublicStay)
    this.getPublicStayGuide()
    this.$store.commit('order/setResetState')
  },

  created() {
    this.getPlanBasicInfo()
  },

  computed: {
    getDataSelectedRadio() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.selected_web_radio', null))
    },
    shareUrl() {
      const { menuNo } = this.$route.query
      return `${location.protocol}//${location.host}/public-stay/menus/${menuNo}`
    },

    stayDateRoom() {
      const data = cloneDeep(get(this.orderPublicStay, 'stayDateRoom', {}))
      data.date = moment(data.date).locale('ja').format('ll')
      return data
    },

    mypageURL() {
      return process.env.VUE_APP_MYPAGE_DOMAIN
    }
  },

  methods: {
    get,

    handleMove(isPublicStay) {
      const menuNo = this.$route.query.menuNo
      const srvicDiv = _.get(this.orderPublicStay, 'stayParam.menuBasicInfo.srvicDiv', null)
      const params = {
        acptNo: _.get(this.completeOrderPublicStay, 'acptNo', null),
        srvicDiv: srvicDiv,
        isPublicStay
      }
      window.location.href =
        this.mypageURL +
        `/mypage/orders/${menuNo}?acptNo=${params.acptNo}&srvicDiv=${params.srvicDiv}&isPublicStay=${params.isPublicStay}`
      // this.$router.push({ path: `/mypage/orders/${menuNo}`, query: params })
    },

    getPlanBasicInfo() {
      const data = cloneDeep(get(this.$store.state.order, 'dataItemPublicStay', {}))

      this.dataItemOrder = {
        type: 'type-small',
        menu_id: get(data, 'menu_id', ''),
        label: get(data, 'label', ''),
        baseImg: get(data, 'baseImg', ''),
        title1: get(data, 'title1', '')
      }
    },

    getPublicStayGuide() {
      const acptNo = _.get(this.completeOrderPublicStay, 'acptNo', null)
      const data = {
        // staffNm: 'string'
      }
      this.$repositories('order')
        .getPublicStayGuide(acptNo, data)
        .then(
          (response) => {
            this.pdfFilePath = _.get(response, 'pdfFilePath', '')
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
    },
    downloadPublicStayGuide(){
      downLoadMixin.$_downloadPdfUrlMixin(this.pdfFilePath);
    },
    copyContent() {
      return location.href
    },

    copySuccess() {
      this.$toasted.success('Copied')
    },

    copyError() {
      this.$toasted.error('Copy failed')
    },

    gotoPath() {
      const query = this.$route.query
      this.$router.push({ path: '/mypage/setting', query })
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
